<template>
    <div>
        <div class="container">
            <b-breadcrumb :items="breadcrumb" v-if="breadcrumb"></b-breadcrumb>

            <div class="row">
                <div class="d-none d-xl-block col-xl-3">
                    <catalog-categories></catalog-categories>
                </div>


                <div class="col-xl-9">

                    <div v-if="deliveryData" class="box-shadow p-0 mb-40">

                        <div class="p-3">
                            <h1 class="as-h2 mb-24">{{deliveryDataName}}</h1>

                            <div v-html="deliveryData"></div>
                        </div>

                    </div>

                    <div v-if="loading" class="loading-box">
                        <b-spinner></b-spinner>
                    </div>

                    <div class="mt-5" v-if="seo_text">
                        <p v-html="seo_text"></p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                loading: true,

                deliveryData: null,
                deliveryDataName: null,

                breadcrumb: null,
                seo_text: null
            }
        },

        watch: {
            $route() {
                this.loading = true;
                this.init();
            },
        },

        mounted() {
            this.init()
        },

        methods: {
            init() {

                let url = '/api/get-custom-data?key=delivery';
                axios.get(url)
                    .then(response => {
                        this.deliveryData = response.data.data.value;
                        this.deliveryDataName = response.data.data.name;
                        this.getBreadcrumb();
                        this.loading = false;

                        let seoInfo = response.data.seoInfo
                        this.seo_text = response.data.seoInfo.seo_text

                        document.title = seoInfo?.seo_title ? seoInfo?.seo_title : 'Доставка и оплата Фотопроката "MRental"';
                        let desc = seoInfo?.seo_desc ? seoInfo?.seo_desc : 'Доставка и оплата Фотопроката "MRental"';
                        document.querySelector('meta[name="description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[property="og:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:text:description"]').setAttribute("content",  desc);
                    })
            },

            getBreadcrumb() {
                this.breadcrumb = [
                    {
                        text: 'Главная',
                        to: {name: 'pages-index'}
                    },
                    {
                        text: "Доставка и оплата",
                        active: true
                    }
                ]
            }
        }
    }
</script>

